import React, { useEffect } from "react";
import { connect } from "react-redux";
import setCoverPresent from '../redux/actions';
import CaseStudyPage from '../components/CaseStudyPage';
import ProjectModel from '../models/ProjectModel';

function Config2025({ dispatch }) {
  useEffect(() => {
    dispatch(setCoverPresent('no'));
  }, []);

  const model = {
    ...ProjectModel.Config2025,
    sections: [
      { type: 'full', cols: 6, ratio: '16 / 9', src: 'img/project-page/config-2025/figma-config25-MariaChimishkyan-1.jpg', caption: 'Exterior graphic' },
      { type: 'half', cols: 3, images: [
        { src: 'img/project-page/config-2025/figma-config25-MariaChimishkyan-2.mp4', ratio: '11 / 14', caption: 'Riso activity sketch' },
        { src: 'img/project-page/config-2025/figma-config25-MariaChimishkyan-3.jpg', ratio: '11 / 14', caption: 'Riso Station' },
      ]},
      { type: 'full', cols: 6, ratio: '16 / 9', src: 'img/project-page/config-2025/figma-config25-MariaChimishkyan-4.jpg', caption: 'Riso Station closeup' },
      { type: 'full', cols: 3, centered: true, ratio: '11/14', src: 'img/project-page/config-2025/figma-config25-MariaChimishkyan-5.mp4', caption: 'Riso poster takeaway' },
      { type: 'half', cols: 3, images: [
        { src: 'img/project-page/config-2025/figma-config25-MariaChimishkyan-6.jpg', ratio: '11 / 14', caption: 'Gestural wall sketches' },
        { src: 'img/project-page/config-2025/figma-config25-MariaChimishkyan-7.jpg', ratio: '11 / 14', caption: 'Gestural wall crop' },
      ]},
      { type: 'full', cols: 6, ratio: '16 / 9', src: 'img/project-page/config-2025/figma-config25-MariaChimishkyan-14.jpg', caption: 'The Figma Store' },
      { type: 'half', cols: 3, images: [
        { src: 'img/project-page/config-2025/figma-config25-MariaChimishkyan-8.mp4', ratio: '11 / 14', caption: 'Store table sketch, gestural glyphs' },
        { src: 'img/project-page/config-2025/figma-config25-MariaChimishkyan-9.jpg', ratio: '11 / 14', caption: 'Store tables' },
      ]},
      { type: 'full', cols: 3, centered: true, ratio: '16 / 9', src: 'img/project-page/config-2025/figma-config25-MariaChimishkyan-13.mp4', caption: 'Badges' },
      { type: 'full', cols: 6, ratio: '16 / 9', src: 'img/project-page/config-2025/figma-config25-MariaChimishkyan-10.jpg', caption: 'Glyph Synthesizer' },
      { type: 'half', cols: 3, images: [
        { src: 'img/project-page/config-2025/figma-config25-MariaChimishkyan-glyphsynth-1.mp4', ratio: '11 / 14', caption: 'Glyph Synthesizer button crop' },
        { src: 'img/project-page/config-2025/figma-config25-MariaChimishkyan-glyphsynth-2.mp4', ratio: '11 / 14', caption: 'Glyph Synthesizer button crop' },
      ]},
      { type: 'full', cols: 6, ratio: '16 / 9', src: 'img/project-page/config-2025/figma-config25-MariaChimishkyan-15.jpg', caption: 'Escalator inflatables' },
      { type: 'full', cols: 6, ratio: '16 / 9', src: 'img/project-page/config-2025/figma-config25-MariaChimishkyan-16.jpg', caption: 'Further inflatables' },
       { type: 'half', cols: 3, images: [
        { src: 'img/project-page/config-2025/figma-config25-MariaChimishkyan-18.jpg', ratio: '11 / 14', caption: 'Inflatable crop' },
        { src: 'img/project-page/config-2025/figma-config25-MariaChimishkyan-17.jpg', ratio: '11 / 14', caption: 'Food hall inflatables' },
        
      ]},
      { type: 'full', cols: 6, ratio: '16 / 9', src: 'img/project-page/config-2025/figma-config25-MariaChimishkyan-19.jpg', caption: 'Wayfinding detail' },
      {
        type: 'tabbed-palette',
        tabs: [
          { label: 'Palette 1', colors: [
            { name: 'Maroon',   pantone: '202 U',  cmyk: '15, 87, 52, 33', rgb: '114, 28, 28',  hex: '#721C1C' },
            { name: 'Hot Pink', pantone: '807 U',  cmyk: '0, 94, 100, 0',  rgb: '255, 1, 229',  hex: '#FF01E5', dark: true },
            { name: 'Lime',     pantone: '2295 U', cmyk: '4, 0, 55, 0',    rgb: '228, 255, 151', hex: '#E4FF97' },
          ]},
          { label: 'Palette 2', colors: [
            { name: 'Teal',        pantone: '2226 U', cmyk: '59, 0, 8, 0',    rgb: '51, 223, 223',  hex: '#33DFDF' },
            { name: 'Dark Purple', pantone: '2371 U', cmyk: '91, 100, 0, 3',  rgb: '93, 68, 147',   hex: '#5D4493' },
            { name: 'Orange',      pantone: '1655 U', cmyk: '0, 60, 83, 0',   rgb: '255, 114, 55',  hex: '#FF7237' },
          ]},
          { label: 'Palette 3', colors: [
            { name: 'Purple',     pantone: '2088 U', cmyk: '62, 69, 0, 0',   rgb: '135, 79, 255',  hex: '#874FFF' },
            { name: 'Dark Green', pantone: '343 U',  cmyk: '82, 21, 61, 53', rgb: '10, 92, 53',    hex: '#0A5C35' },
            { name: 'Hot Red',    pantone: '032 U',  cmyk: '0, 91, 100, 0',  rgb: '255, 55, 55',   hex: '#FF3737', dark: true },
          ]},
          { label: 'Palette 4', colors: [
            { name: 'Blue',   pantone: '2726 U', cmyk: '70, 76, 0, 0',  rgb: '77, 73, 252',   hex: '#4D49FC' },
            { name: 'Peach',  pantone: '489 U',  cmyk: '0, 21, 20, 0',  rgb: '255, 201, 193', hex: '#FFC9C1' },
            { name: 'Yellow', pantone: '3935 U', cmyk: '4, 0, 55, 0',   rgb: '250, 253, 93',  hex: '#FAFD5D' },
          ]},
        ],
        shared: [
          { name: 'Cyan',         pantone: '306 U',     cmyk: '79, 0, 0, 0',    rgb: '0, 182, 255',   hex: '#00B6FF' },
          { name: 'Dusty Violet', pantone: '2078 U',    cmyk: '19, 40, 0, 0',   rgb: '203, 159, 210', hex: '#CB9FD2' },
          { name: 'Sage',         pantone: '623 U',     cmyk: '41, 10, 28, 3',  rgb: '149, 185, 172', hex: '#95B9AC' },
          { name: 'Kelly Green',  pantone: '7479 U',    cmyk: '76, 0, 87, 0',   rgb: '36, 203, 113',  hex: '#24CB71' },
          { name: 'Black',        pantone: 'Black 6 U', cmyk: '60, 40, 40, 100', rgb: '0, 0, 0',      hex: '#000000' },
          { name: 'Medium Grey',  pantone: '424 U',     cmyk: '41, 31, 30, 22', rgb: '109, 110, 109', hex: '#6D6E6D' },
          { name: 'White',        pantone: null,        cmyk: '0, 0, 0, 0',     rgb: '255, 255, 255', hex: '#FFFFFF' },
        ],
      },
    ],
  };

  return <CaseStudyPage projectModel={model} />;
}

export default connect()(Config2025);
